<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>用户类型管理</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                v-model.trim="filters.typeName"
                placeholder="用户类型昵称"
                clearable
                size="mini"
                prefix-icon="el-icon-search"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="openAdd">新增</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table
        :data="tableList"
        height="calc(100vh - 300px)"
        size="mini"
        v-loading="loading"
      >
        <el-table-column label="编号" width="80" align="left">
          <template slot-scope="scope">
            {{ rowIndex(scope.$index) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="用户类型昵称"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="createdTime" label="创建时间" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openView(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>

      <UserTypeFormDialog
        v-model="formVisible"
        :mode="formMode"
        :user-type-id="currentId"
        @success="fetchList"
      />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import UserTypeFormDialog from './components/UserTypeFormDialog.vue'
import api from './api'
import { PAGINATION } from './constants'

function createFilters() {
  return { typeName: '' }
}

export default {
  name: 'WelfareUserType',
  components: { Pagination, UserTypeFormDialog },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      formVisible: false,
      formMode: 'add',
      currentId: null,
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    rowIndex(index) {
      return (this.pagination.page - 1) * this.pagination.size + index + 1
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = createFilters()
      this.pagination = { ...PAGINATION }
      this.fetchList()
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size }
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
      }
      if (this.filters.typeName) query.typeName = this.filters.typeName
      api
        .list(query)
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {}
            this.tableList = d.items || d.records || d.list || []
            this.totalCount =
              d.total != null ? d.total : d.totalCount != null ? d.totalCount : 0
          } else {
            this.tableList = []
            this.totalCount = 0
            this.$message.error((res && res.msg) || '查询失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd() {
      this.formMode = 'add'
      this.currentId = null
      this.formVisible = true
    },
    openView(row) {
      this.formMode = 'view'
      this.currentId = row.id
      this.formVisible = true
    },
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
</style>
